import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SelectFormatCallback, SelectItem, SelectSelectingEvent, SelectService } from './select.service';
import { NgIf } from '@angular/common';

export interface ChangedItemsEvent {
  selectedItems: string[];
}

@Component({
  selector: 'app-select',
  template: `<input
      id="{{ id }}"
      class="text long-field"
      placeholder="{{ placeholder }}"
      type="text"
      [disabled]="!enabled"
    />
    <span
      *ngIf="showClearAll && selectedItems && selectedItems.length > 0"
      (click)="clearAllItems()"
      title="Clear all"
      class="aui-icon aui-icon-small aui-iconfont-cross-circle select-clear-all"
    ></span>`,
  providers: [SelectService],
  imports: [NgIf],
})
export class SelectComponent implements OnChanges, AfterViewInit {
  @Input() id = '';
  @Input() multiple = false;
  @Input() placeholder = 'Select an item';
  @Input() items: SelectItem[] = [];
  @Input() initItemIds: string[] = [];
  @Input() enabled = true;
  @Input() format?: SelectFormatCallback;
  @Input() showClearAll = false;
  @Output() changeEvent = new EventEmitter();
  selectedItems: SelectItem[] | undefined;

  constructor(private selectService: SelectService) {}

  ngAfterViewInit(): void {
    // TODO: Check the performace, maybe we should improve it
    this.selectedItems = [];
    if (this.items.length > 0) {
      if (this.initItemIds.length > 0) {
        this.selectedItems = this.items.filter(item => {
          return this.initItemIds.includes(item.id as string);
        });
      }
    }

    if (!this.multiple) {
      this.buildSingle();
    } else {
      this.buildMultip();
    }
  }

  ngOnChanges(changes: any): void {
    // TODO: Check the performace, maybe we should improve it
    this.ngAfterViewInit();
  }

  private buildMultip(): void {
    const elemSelector = `#${this.id}`;
    this.selectService.initSelect({
      elemSelector,
      placeholder: this.placeholder,
      items: this.items,
      initSelection: (element: unknown, callback: unknown) => {
        if (this.selectedItems?.length) {
          if (typeof callback === 'function') {
            callback(this.selectedItems);
          }
        }
      },
      changeCallback: event => {
        this.changeEvent.emit({ selectedItems: event.val });
      },
    });
  }

  clearAllItems(): void {
    if (!this.showClearAll) return;

    this.selectedItems = [];
    this.initItemIds = [];
    this.selectService.clearAll(`#${this.id}`);
  }

  private buildSingle(): void {
    const elemSelector = `#${this.id}`;

    this.selectService.initSelect({
      elemSelector,
      placeholder: this.placeholder,
      items: this.items,
      formatCallback: this.format,
      initSelection: (element: unknown, callback: unknown) => {
        if (this.selectedItems?.length) {
          const selectedOption = this.selectedItems[0];
          selectedOption.locked = true;
          if (typeof callback === 'function') {
            callback([selectedOption]);
          }
        }
      },
      changeCallback: () => {
        this.changeEvent.emit({ selectedItems: this.selectedItems?.map(selectedItem => selectedItem.id) });
      },
      selectingCallback: (event: SelectSelectingEvent) => {
        event.preventDefault();
        if (event.object) {
          this.selectedItems = [event.object];
          this.selectService.setValuesAndClose(elemSelector, [event.object]);
        }
      },
    });

    this.selectService.setEnableDisable(elemSelector, this.enabled);
  }
}
